import * as Yup from "yup";

export const leadVoiceSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  phone: Yup.string().matches(
    new RegExp("[0-9]{12}"),
    "Phone number is not valid"
  ),
  email: Yup.string().email("Please enter valid Username i.e email"),
  dob: Yup.date(),
  gender: Yup.string().required("Gender is required"),
  assignedStaff: Yup.object().nullable().required("Staff is required"),
});
